<template>
    <div style="padding: 20px; height: 100%; box-sizing: border-box">
        <div style="padding-bottom: 10px; text-align: left">
            <span style="margin-right: 10px;">{{ name }}</span>
            <el-select v-model="search.status" placeholder="选择状态" size="mini" @change="init" clearable>
                <el-option v-for="(item, index) in statusList" :key="index" :value="item.value"
                           :label="item.label"></el-option>
            </el-select>
            <el-input v-model="search.keyWord" placeholder="输入关键词" size="mini" @change="init" clearable
                      style="width: 300px; margin:0 10px"></el-input>
            <el-button size="mini" @click="init">刷新</el-button>
        </div>
        <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading">
            <el-table-column prop="platformName" label="站台名称" min-width="180"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="tenantName" label="企业名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tenantCode" label="企业编码" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userName" label="用户名称" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="手机号" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="审核时间" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                    <el-tag size="mini"
                            :type="scope.row.status === 'wait' ? 'primary' : scope.row.status === 'refuse' ? 'danger' : 'success'">
                        {{ scope.row.status === 'wait' ? '待审核' : scope.row.status === 'refuse' ? '拒绝' : '通过' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="100" label="操作">
                <template slot-scope="scope" v-if="scope.row.status === 'wait'">
                    <el-button size="mini" type="text" @click="getOperate(scope.row, 'adopt')">通过</el-button>
                    <el-button size="mini" type="text" @click="getOperate(scope.row, 'refuse')">拒绝</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: left; padding: 10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="page.current"
                           :page-sizes="[20, 50, 80, 100]" :page-size="page.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="page.total" background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'platformAudit',
    data() {
        return {
            data: [],
            page: {
                total: 0,
                size: 20,
                current: 1
            },
            loading: false,
            search: {
                status: '',
                keyWord: ''
            },
            statusList: [
                {value: 'wait', label: '待审核'},
                {value: 'adopt', label: '通过'},
                {value: 'refuse', label: '拒绝'}
            ],
            name: ''
        }
    },
    props: {
        type: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            const params = {
                params: {
                    pageNum: this.page.current,
                    pageSize: this.page.size
                }
            }
            for (let key in this.search) {
                if (this.search[key]) {
                    params.params[key] = this.search[key]
                }
            }
            this.loading = true
            let url
            if (this.type === 'mcsh') {
                this.name = '煤储站台审核'
                url = 'https://platform.ncexc-rm.com/api/internal/userRegister/list'
            } else {
                this.name = '站台审核'
                url = '/internal/userRegister/list'
            }
            this.$axios.get(url, params).then(res => {
                this.data = res.data.data.list
                this.page.total = res.data.data.total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange(val) {
            this.page.size = val
            this.init()
        },
        handleCurrentChange(val) {
            this.page.current = val
            this.init()
        },
        getOperate(row, status) {
            let text, url
            if (status === 'adopt') {
                text = '通过'
            } else {
                text = '拒绝'
            }
            if (this.type === 'mcsh') {
                url = `https://platform.ncexc-rm.com/api/internal/userRegister/examine/${row.id}/${status}`
            } else {
                url = `/internal/userRegister/examine/${row.id}/${status}`
            }
            this.$confirm(`确定${text}该单据吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$axios.post(url).then(() => {
                    this.$message.success(`已${text}该单据`)
                    this.init()
                })
            }).catch(() => {
            })
        },
        getRefuse(row) {
            console.log(row)
        }
    }

}
</script>